
import styled from 'styled-components'
import Flex from '../../Flex'
import Box from '../../Box'
import { themeColor } from '../../../util/themeLenses'

export const Container = styled(Flex)`
    box-shadow: 0px 2px 4px 0px ${themeColor('lightGray40')};
    border: 1px solid ${themeColor('lightGray40')};
    min-height: 125px;
    border-radius: 2px;
`

export const InfoContainter = styled(Box)`
    position: relative;
`


